import { Routes, Route } from "react-router-dom";
import React from "react";
import TeaserPageLayout from "components/security/teaser/TeaserPageLayout";
import AppRoutes, { SECURITY_PATH } from "routing/Routes";
import { Overview, UserActivity, HostActivity, NetworkActivity, Anomalies } from "components/security/pages";
const subRoutes = [
  { path: AppRoutes.SECURITY.OVERVIEW, element: /* @__PURE__ */ React.createElement(Overview, null) },
  { path: AppRoutes.SECURITY.USER_ACTIVITY, element: /* @__PURE__ */ React.createElement(UserActivity, null) },
  { path: AppRoutes.SECURITY.HOST_ACTIVITY, element: /* @__PURE__ */ React.createElement(HostActivity, null) },
  { path: AppRoutes.SECURITY.NETWORK_ACTIVITY, element: /* @__PURE__ */ React.createElement(NetworkActivity, null) },
  { path: AppRoutes.SECURITY.ANOMALIES, element: /* @__PURE__ */ React.createElement(Anomalies, null) }
].map((route) => ({ ...route, path: route.path.slice(SECURITY_PATH.length) }));
const SecurityPage = () => /* @__PURE__ */ React.createElement(TeaserPageLayout, null, /* @__PURE__ */ React.createElement(Routes, null, subRoutes.map(({ path, element }) => /* @__PURE__ */ React.createElement(Route, { key: path, path, element }))));
export default SecurityPage;
